import { useMobileMediaQuery } from '@/hooks/useMobileMediaQuery';
import { FC, lazy } from 'react';

const MaterialsPageDefaultView = lazy(() => import('./default-view/MaterialsPageDefaultView'));

const MaterialsPageMobileView = lazy(() => import('./mobile-view/MaterialsPageMobileView'));

export const MaterialsPage: FC = () => {
  const isMobile = useMobileMediaQuery();

  return isMobile ? <MaterialsPageMobileView /> : <MaterialsPageDefaultView />;
};
